import useApiController from "@hooks/useApiController"

export default function useSalonDashboardController(salonId: string | number): Admin.Controllers.SalonDashboard {
    const controller = useApiController(`/api/admin/salons/${salonId}/dashboard`)

    const current = controller.get("current")
    const voting = controller.get("voting")
    const finished = controller.get("finished")
    const tracking = controller.get("tracking")

    return { current, voting, finished, tracking }
}